export default "__VITE_PUBLIC_ASSET__2b1eb826__"